export const AppRoutes = {
  HOME: '',
  EVENT_DETAILS: 'events',
  JOIN_PLATFORM: 'join-platform',
  PRIVACY_POLICY: 'privacy-policy',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  COMPANIES: {
    ROOT: 'companies',
    COMPANY_ID: 'companyId',
    RESERVATION: 'reservation',

    DETAILS: (companyId: string) => `/${AppRoutes.COMPANIES.ROOT}/${companyId}`,
    RESERVATION_CREATE: (companyId: string) =>
      `/${AppRoutes.COMPANIES.ROOT}/${companyId}/${AppRoutes.COMPANIES.RESERVATION}`,
  },
  EVENT_DETAILS_LINK: (companyId: string, eventId: string) =>
    `/${AppRoutes.EVENT_DETAILS}/${companyId}/${eventId}`,
};
